module.exports = require("png2icons");;